import Form from "../components/Form";
import { debounce } from "../inc/helpers";

export default class PageSingleOpenPosition {
  constructor() {
    this.data = null;
    this.form = document.querySelector("main > .wpcf7");    
    
    if (!this.form) {
      this.form = document.querySelector("main > *:has(.wpcf7)");    
    }     
    this.btn_cta_form = document.querySelector(".js-btn-scrolltoform");
  }

  init(data) {
    this.data = data;
    
    if (!this.form) 
      return;
    
    this.form_obj = new Form(this.data, this.form);
    this.form_obj.init();

    this.init_sticky_elems();
    this.btn_cta_form?.addEventListener("click", (e) => {
      this.form?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    });
  }

  init_sticky_elems() {
    const elem = document.querySelector(".js-sticky-elem");    
    // select el immediatly previous to form    
    let target = this.form.previousElementSibling;
    
    if (!(elem && target)) return;

    let nav_h = document.querySelector(".js-site-header")?.offsetHeight;    
    let f_size = parseInt(window.getComputedStyle(document.body).getPropertyValue("font-size")) * 2;
    const start = elem.parentNode.offsetTop - nav_h - f_size;
    const stop = start + target.offsetTop + target.offsetHeight - elem.offsetHeight;
    
    const handle_scroll = () => {
      if (window.scrollY > stop) {
        elem.classList.remove("is-sticky");
        elem.style.setProperty(
          "--w",
          `${elem.offsetWidth}px`
        );
        elem.style.setProperty(
          "--top", 
          `${target.offsetTop + target.offsetHeight - elem.offsetHeight}px`
        );
        elem.classList.add("is-absolute");
        
      } else if (window.scrollY > start) {
        elem.classList.remove("is-absolute");

        !elem.classList.contains("is-sticky")
          && elem.classList.add("is-sticky");        
        
      } else {
        elem.classList.remove("is-sticky");        
      }
    };

    window.addEventListener("scroll", handle_scroll);
    window.addEventListener("resize", () => debounce(() => {
      nav_h = document.querySelector(".js-site-header")?.offsetHeight;
      f_size = parseInt(window.getComputedStyle(document.body).getPropertyValue("font-size"));

      handle_scroll();
    }));
    
    handle_scroll();
  }
}